import { EventRegistry } from '../../../../../domain/event/event.registry';
import { PhotoEvent } from '../../../../photo/photo/domain/event/photo.event';
export class PhotosLinkedToAssetEvent extends PhotoEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: PhotosLinkedToAssetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
PhotosLinkedToAssetEvent.type = 'com.treeplotter.api.photo.photosLinkedToAsset.v1';
EventRegistry.register(PhotosLinkedToAssetEvent.type, PhotosLinkedToAssetEvent);
//# sourceMappingURL=photos-linked-to-asset.event.js.map